import { render } from "./AboutWebsite.vue?vue&type=template&id=6fd0e411"
import script from "./AboutWebsite.vue?vue&type=script&lang=js"
export * from "./AboutWebsite.vue?vue&type=script&lang=js"

import "./AboutWebsite.vue?vue&type=style&index=0&id=6fd0e411&lang=css"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__